import axios, { InternalAxiosRequestConfig } from 'axios';
import ErrorDialogController from '../context/error-dialog-controller';

import { AxiosRequestConfig } from 'axios';

export interface CustomAxiosRequestConfig<T = any> extends AxiosRequestConfig<T> {
  skipAuth?: boolean;
}

/**
 * axiosInstance
 */
export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

/**
 * リクエストごとに Authorization ヘッダーを動的に設定
 */

axiosInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const skipAuth = (config as InternalAxiosRequestConfig & { skipAuth?: boolean }).skipAuth;

  if (!skipAuth) {
    const token = getAuthToken();
    if (token) {
      // headers が AxiosHeaders 型であることを前提に set() を使う
      config.headers.set('Authorization', `Bearer ${token}`);
    }
  }

  return config;
});

/**
 * トークンを取得
 * @returns 
 */
const getAuthToken = (): string | null => {
    const raw = localStorage.getItem("auth");
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        return parsed.idToken || null;
    } catch {
        return null;
    }
};

/**
 * 
 */
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    const code = error?.code;

    if (code === 'ERR_NETWORK') {
      ErrorDialogController.show({
        title: 'ネットワークエラー',
        message: 'インターネット接続またはサーバーが応答していません。',
        onClose: () => ErrorDialogController.go('/login')
      });
    } else if (status === 400) {
      ErrorDialogController.show({
        title: '入力エラー',
        message: '送信内容に誤りがあります。',
      });
    } else if (status === 401) {
      ErrorDialogController.show({
        title: '認証エラー',
        message: 'ログイン状態が無効です。',
        onClose: () => ErrorDialogController.go('/login')
      });
    } else if (status === 403) {
      ErrorDialogController.show({
        title: '認証エラー',
        message: 'ログイン状態が無効です。',
        onClose: () => ErrorDialogController.go('/login')
      });
    } else if (status === 500) {
      ErrorDialogController.show({
        title: 'システムエラー',
        message: 'システムエラーが発生しました。',
      });
    } else {
      ErrorDialogController.show({
        title: '通信エラー',
        message: 'サーバーとの通信に失敗しました。',
      });
    }

    return Promise.reject(error);
  }
);